import { IScope } from 'angular'
import { trackError } from '@vend/utilities'
import { $compile, $rootScope } from '../../ng-compat/imports'
import { WR_PRINTER_ID } from '../../directives/application/wr-printer'
import { ReceiptData } from '../../managers/sale-manager'
import { RegisterClosurePrintData } from '../../util/register-closure-types'

type ReceiptPrintType =
  | 'open-drawer'
  | 'receipt'
  | 'receipt-settings-and-template'
  | 'styled-gift-receipt'

type ReceiptPrintPayload = {
  type: ReceiptPrintType
  data?: Readonly<ReceiptData | RegisterClosurePrintData>
}

type ClosurePrintPayload = {
  type: 'register-closure'
  data?: Readonly<RegisterClosurePrintData>
}

export type PrintPayload = ReceiptPrintPayload | ClosurePrintPayload

export interface PrintController {
  _print(options: PrintPayload): Promise<void>
}

export interface PrinterScope extends IScope {
  printerCtrl: PrintController
}

export async function print(printPayload: PrintPayload): Promise<void> {
  const printScope = $rootScope.$new() as PrinterScope
  const printDirective = $compile(`<${WR_PRINTER_ID}></${WR_PRINTER_ID}>`)(
    printScope
  )

  document.body.appendChild(printDirective[0])

  try {
    // Convert to regular promise
    const printPromise = new Promise<void>((resolve, reject) => {
      printScope.printerCtrl._print(printPayload).then(resolve, reject)
    })
    await printPromise
  } catch (error) {
    trackError('[Print] Error when printing', { error })
  } finally {
    printDirective.remove()
    printScope.$destroy()
  }
}
